 $(document).ready(function () {
 $('#site_builder--sidebarCollapse').on('click', function () {
   $('#site_builder--sidebar, #content, #site_builder--sidebarCollapse').toggleClass('active');
   $('#home-btn').toggleClass('active')
   $('#site_builder--open_sidebar').toggleClass('fa-rotate-180');
   $('.collapse.in').toggleClass('in');
   $('a[aria-expanded=true]').attr('aria-expanded', 'false');
 });
});

